// https://github.com/fullstackreact/google-maps-react

import React, { Component } from 'react';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
import C from "../Const";

const mapStyles = {
    width: '100%',
    height: '100%'
};

export class DynamicScenarioMap extends Component {

    state = {
        showingInfoWindow: false,  // Hides or the shows the infoWindow
        activeMarker: {},          // Shows the active marker upon click
        selectedPlace: {},         // Shows the infoWindow to the selected place upon a marker
        start_lla: this.props.start_lla,
        finish_lla: this.props.finish_lla,
    };


    render() {
        return (
            <Map
                google={this.props.google}
                zoom={8}
                style={mapStyles}
                initialCenter={{
                    lat: this.props.start_lla[0],
                    lng: this.props.start_lla[1]
                }}
            >
                <Marker
                    onClick={this.onMarkerClick}
                    name={'Start Location'}
                    kind={'start'}
                    draggable={true}
                    onDragend={this.moveMarker.bind(this)}
                    position={{lat: this.state.start_lla[0], lng: this.state.start_lla[1]}}
                />
                <Marker
                    onClick={this.onMarkerClick}
                    name={'Finish Location'}
                    kind={'finish'}
                    draggable={true}
                    onDragend={this.moveMarker.bind(this)}
                    position={{lat: this.state.finish_lla[0], lng: this.state.finish_lla[1]}}
                />
                <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                    onClose={this.onClose}
                >
                    <div>
                        <h4>{this.state.selectedPlace.name}</h4>
                    </div>
                </InfoWindow>
            </Map>
        );
    }

    moveMarker = (props, marker, coord) => {
        console.log("Lat %f", coord.latLng.lat());
        console.log("Lon %f", coord.latLng.lng());
        const lla = [coord.latLng.lat(), coord.latLng.lng(), 0];

        if( props.kind === 'start' ) {
            console.log("Updated start location");
            this.setState({start_lla: lla});
        }
        else {
            console.log("Updated finish location");
            this.setState({finish_lla: lla});
        }
    };

    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const change =  (prevState.start_lla[0] !== this.state.start_lla[0])
            || (prevState.start_lla[1] !== this.state.start_lla[1])
            || (prevState.finish_lla[0] !== this.state.finish_lla[0])
            || (prevState.finish_lla[1] !== this.state.finish_lla[1])
        ;

        if( change ) {
            this.props.onLlaChange(this.state.start_lla, this.state.finish_lla);
        }
    };

}

export default GoogleApiWrapper({
    apiKey: C.GOOGLE_MAP_API_KEY
})(DynamicScenarioMap);
